<template>
    <div>
        <table class="table condensed">
            <thead>
                <tr>
                    <th>Namn</th>
                    <th>Etikett/roll</th>
                    <th>Telefon</th>
                    <th>E-post</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="contact in contacts">
                    <td>
                        {{ contact.name }}
                    </td>
                    <td>
                        {{ contact.role }}
                    </td>
                    <td>
                        {{ contact.phone }}
                    </td>
                    <td>
                        {{ contact.email }}
                    </td>
                    <td class="actions">
                        <div>
                            <button
                                class="btn-icon hover:bg-danger hover:border-danger"
                                @click="deleteContact(contact)"
                            >
                                <font-awesome-icon icon="trash-alt" size="xs" />
                            </button>
                            <button
                                class="btn-icon"
                                @click="editContact(contact)"
                            >
                                <font-awesome-icon icon="pencil" size="sm" />
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="text-right">
            <button
                class="btn is-primary mt-lg"
                @click="$modal.show('add-contact')"
            >
                Lägg till kontaktperson
            </button>
        </div>

        <adaptive-form-modal
            name="add-contact"
            method="post"
            primary-button-text="Spara kontaktperson"
            primary-button-class="is-primary"
            title="Lägg till kontaktperson"
            :action="storeActionRoute"
            :callback="storeContact"
        >
            <group-contact-form />
        </adaptive-form-modal>

        <adaptive-form-modal
            name="edit-contact"
            method="patch"
            primary-button-text="Uppdatera kontaktperson"
            primary-button-class="is-primary"
            title="Redigera kontaktperson"
            :action="updateActionRoute"
            :callback="updateContactCallback"
        >
            <group-contact-form :contact="selectedContact" />
        </adaptive-form-modal>
    </div>
</template>

<script>
    import GroupContactForm from './GroupContactForm';

    export default {
        components: { GroupContactForm },
        props: {
            project: {
                required: true,
                type: Object,
            },
            group: {
                required: true,
                type: Object,
            },
            initialContacts: {
                required: true,
                type: Array,
            },
        },

        data() {
            return {
                contacts: this.initialContacts,
                selectedContact: {},
            };
        },

        computed: {
            storeActionRoute() {
                return route('api.sales-projects.groups.group-contacts.store', [this.project, this.group]);
            },
            updateActionRoute() {
                return route('api.sales-projects.groups.group-contacts.update', [this.project, this.group, this.selectedContact.id]);
            },
        },

        methods: {
            storeContact(response) {
                this.contacts.push(response.data.contact);
                this.$modal.hide('add-contact');
            },

            deleteContact(contact) {
                axios.delete(route('api.sales-projects.groups.group-contacts.destroy', [this.project, this.group, contact.id]))
                    .then(() => {
                        const index = this.contacts.findIndex(contactItem => contact.id === contactItem.id);
                        if (index >= 0) {
                            this.contacts.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        flash_error('Kunde inte ta bort kontaktpersonen');
                    });
            },

            editContact(contact) {
                const { id, name, role, phone, email } = contact;
                this.selectedContact = {
                    id,
                    name,
                    role,
                    phone,
                    email,
                };

                this.$modal.show('edit-contact');
            },

            updateContactCallback({ data }) {
                this.contacts = data.contacts;

                this.$modal.hide('edit-contact');

                flash_success('Kontaktinformationen uppdaterades');
            },
        },
    };
</script>
